import { FC, useDeferredValue, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { applyItemListQuery } from "@/hooks/useInventorySortSearch"
import { InventoryToolbar } from "../InventoryToolbar"
import { ItemGrid } from "../ItemGrid"
import { WeightBar } from "../WeightBar"
import styles from "./InventoryListPanel.module.scss"
import { IInventoryListPanelProps } from "./types"

export const InventoryListPanel: FC<IInventoryListPanelProps> = ({
  items,
  weight,
  query,
  ctx,
  onQueryChange,
  onItemClick
}) => {
  const { t } = useTranslation("inventory")
  const deferredSearch = useDeferredValue(query.search)

  const list = useMemo(
    () =>
      applyItemListQuery(
        items,
        { sortKey: query.sortKey, search: deferredSearch },
        ctx
      ),
    [items, query.sortKey, deferredSearch, ctx]
  )

  const settled = deferredSearch === query.search
  const showNoResults =
    settled && query.search.trim() !== "" && list.length === 0

  return (
    <div className={styles.InventoryListPanel}>
      <WeightBar weight={weight} />
      <InventoryToolbar query={query} onQueryChange={onQueryChange} />
      {showNoResults ? (
        <p className={styles.InventoryListPanel_noResults}>
          {t("search.noResults")}
        </p>
      ) : (
        <ItemGrid items={list} onItemClick={onItemClick} />
      )}
    </div>
  )
}
